import React from "react";
import PageBody from "Common/Custom/PageBody";
import AddItemBtn from "Common/Custom/AddItemBtn";
import { HeadingOne } from "Common/Custom/HeadingOne";
import BlogListTable from "./Components/BlogListTable";

const BlogList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Blog List</HeadingOne>
                    <div className="d-flex gap-2 flex-wrap mt-sm-0 mt-2">
                        <AddItemBtn url="add-blog" title="Add Blog" />
                    </div>
                </>
            }
        >
            <div className="col-12">
                <BlogListTable />
            </div>
        </PageBody>
    );
};

export default BlogList;
